<template>
  <div class="flex h-full flex-col bg-gradient-to-b from-[#eef2f2] to-[#e4e9e9]">
    <div class="min-h-0 flex-1 p-3">
      <IPhonePreview>
        <header v-if="document?.content?.[0]?.type !== 'cover'" class="pb-[10px]">
          <p v-if="bookName" class="text-[9px] font-bold uppercase tracking-[2px] text-[#3e546c]/50">{{ bookName }}</p>
          <h1 class="preview-title mt-[3px] text-[22px] font-bold leading-[27px] text-[#3e546c]">{{ title }}</h1>
          <p v-if="description" class="mt-[5px] text-[13px] leading-[19px] text-[#3e546c]/60">{{ description }}</p>
        </header>
        <DocumentReader :document="document" />
        <div class="mt-[24px] flex h-[48px] items-center justify-center gap-[8px] rounded-[12px] bg-[#1c4848] text-[14px] font-semibold text-white">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.300 14.400-4-4 1.500-1.500 2.500 2.500 5.600-5.600 1.500 1.500-7.100 7.100Z"/></svg>
          {{ languageId === 2 ? 'Gotovo' : 'Done' }}
        </div>
      </IPhonePreview>
    </div>
    <p class="shrink-0 px-6 pb-3 text-center text-[11px] leading-snug text-[#1c4848]/50">The next version of the app. Older versions show the same words in simpler blocks.</p>
  </div>
</template>

<script setup>
import { computed, provide } from 'vue';
import DocumentReader from '@/components/writer/reader/DocumentReader.vue';
import IPhonePreview from '@/components/writer/reader/IPhonePreview.vue';

const props = defineProps({
  document: { type: Object, default: null },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  bookName: { type: String, default: '' },
  languageId: { type: Number, default: 1 },
});

provide('readerLanguageId', computed(() => props.languageId));
</script>

<style scoped>
.preview-title { font-family: 'New York', ui-serif, Georgia, 'Times New Roman', serif; }
</style>
